import { Button, Container } from '@/components';
import React, { useEffect } from 'react';
import { AiOutlineUpload } from 'react-icons/ai';
import { IoCreateOutline } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import BtsTable from './BtsTable';
import { useBts } from '@/context/btsContext/BtsContextProvider';

const BtsView = () => {
  const { setBtsSchool, initialState } = useBts();

  useEffect(() => {
    if (setBtsSchool) {
      setBtsSchool(initialState);
    }
  }, [setBtsSchool, initialState]);
  return (
    <Container title={'BTS Home'}>
      <div className="flex justify-between m-5">
        <Link to="/bts/upload" className="">
          <Button className="btn btn-primary">
            <span className="mr-2">
              <AiOutlineUpload size={20} />
            </span>
            Upload BTS File
          </Button>
        </Link>
        <div className="flex gap-4">
          <Link to="/bts/upload-bts-proposal" className="">
            <Button className="btn btn-secondary">
              <span className="mr-2">
                <IoCreateOutline size={20} />
              </span>
              Upload BTS Proposal
            </Button>
          </Link>
          <Link to="/bts/create-proposal" className="">
            <Button className="btn btn-secondary">
              <span className="mr-2">
                <IoCreateOutline size={20} />
              </span>
              Create BTS Proposal
            </Button>
          </Link>
        </div>
      </div>
      <BtsTable />
    </Container>
  );
};

export default BtsView;
